import React from 'react';
import { mui } from '@local/finsera-core/src/libs';

export const FinDataGridFilterDialog = React.memo(function FinDataGridFilterDialog() {
  const apiRef = mui.dataGrid.useGridApiContext();

  const handleClose = React.useCallback(() => {
    apiRef.current.hidePreferences();
  }, [apiRef]);

  return (
    <mui.core.Dialog
      open
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      keepMounted
      hideBackdrop
      disableScrollLock
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
        },
      }}
    >
      <mui.core.DialogTitle sx={{ pb: 1.5, px: 3, pt: 3 }}>Filters</mui.core.DialogTitle>

      <mui.core.DialogContent
        sx={{
          px: 3,
          pb: 3,
          pt: 1,
          '.MuiDataGrid-filterForm': {
            display: 'flex',
            alignItems: 'flex-end',
            columnGap: 2,
            rowGap: 1.5,
            py: 1,
            '& .MuiFormControl-root': {
              minWidth: 120,
            },
            '& .MuiDataGrid-filterFormDeleteIcon': {
              alignSelf: 'center',
              mb: 0.5,
            },
            '& .MuiDataGrid-filterFormColumnInput': {
              minWidth: 150,
            },
            '& .MuiDataGrid-filterFormOperatorInput': {
              minWidth: 100,
            },
            '& .MuiDataGrid-filterFormValueInput': {
              minWidth: 180,
              flexGrow: 1,
            },
          },
          '.MuiDataGrid-panelFooter': {
            pt: 2,
            pb: 1,
            px: 0,
          },
        }}
      >
        <mui.dataGrid.GridFilterPanel />
      </mui.core.DialogContent>
    </mui.core.Dialog>
  );
});
